import React from 'react'
import error from '../error.png'
import PropTypes from 'prop-types'
// Modal-based help icons replace the old inline tooltip (InfoBox)
// import InfoBox from './InputRowHoverOrClickInfo'
import { getDevice } from './CheckDevice'
export default class InputRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      mouseOver: false
    }
    // Generate a unique ID to prevent Duplicate ID warnings
    this.uniqueId = props.name + '_' + props.rowName.replace(/[^a-zA-Z0-9]/g, '') + '_' + Math.random().toString(36).substr(2, 5)
  }

  render () {
    const userDevice = getDevice()
    let classNameofMainDiv = 'input-control'
    if (this.props.name === 'select') {
      classNameofMainDiv = 'input-control select-box'
    }
    return (
      <div className="wrapper">
        <div className="input-wrapper-main">
          <div className={classNameofMainDiv} style={this.props.errMsg ? { borderWidth: 1, borderColor: 'red' } : null}>
            <span className="label">{this.props.rowName}<label style={{ color: 'red' }}>{this.props.required}</label></span>
            {this.props.name === 'select'
              ? <select
                onChange={(e) => {
                  if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                  this.props.onChange(e.target.value)
                }
                }
                id={this.uniqueId}
                value={this.props.value}
                disabled={this.props.disabled}>
                {this.props.data.length ? <option value={''} key={0 + '' + this.props.rowName}>Select</option> : null}
                {this.props.data.length ? this.props.data.map(element => {
                  return <option value={element.Id} key={element.Id + ' ' + element.value}>{element.value}</option>
                }) : <option value={0} key={'Select'}>Select</option>}

              </select>
              : ['date', 'percent'].indexOf(this.props.name) !== -1
                ? <input
                  type={this.props.name}
                  id={this.uniqueId}
                  value={this.props.value}
                  direction= {this.props.direction}
                  disabled={this.props.disabled}
                  onChange={(e) => {
                    if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                    this.props.onChange(e.target.value)
                  }
                  }
                  onKeyDown={e => e.preventDefault(alert('Please use the calendar control icon to modify the dates'))}
                  onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                  min={this.props.name === 'date' ? '1900-01-01' : null}
                  max={this.props.name === 'date' ? '2050-12-31' : null}
                />

                : ['number', 'percent'].indexOf(this.props.name) !== -1
                  ? <input
                    type='number'
                    step={this.props.name === 'percent' ? 0.01 : 1}
                    min={0}
                    max={this.props.name === 'percent' ? 100 : null}
                    id={this.uniqueId}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    onChange={(e) => {
                      if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                      this.props.onChange(e.target.value)
                    }
                    }
                    onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                  />
                  : <input
                    type={this.props.name}
                    id={this.uniqueId}
                    value={this.props.value}
                    direction= {this.props.direction}
                    disabled={this.props.disabled}
                    onChange={(e) => {
                      if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                      this.props.onChange(e.target.value)
                    }
                    }
                    onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                    min={this.props.name === 'date' ? '1900-01-01' : null}
                    max={this.props.name === 'date' ? '2050-12-31' : null}
                  />
            }

            {this.props.error
              ? <div>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  <img src={error} alt={this.props.rowName + ' is not valid'} style={{ width: 15, height: 15 }} />
                  <p>{this.props.rowName} is not valid.</p>
                </div>
              </div>
              : null}
          </div>
          {
            this.props.hover ? (
              <i
                className='fa fa-question-circle'
                aria-hidden='true'
                title='Click for more info'
                style={{ cursor: 'pointer', color: '#3168cd', marginLeft: 6, fontSize: 15 }}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ mouseOver: !this.state.mouseOver }) }}
              />
            ) : null
          }
          {this.state.mouseOver && this.props.hover && (
            <div className='modal-bg' onClick={() => this.setState({ mouseOver: false })}>
              <div className='modal' onClick={(e) => e.stopPropagation()}>
                <div className='header' style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', margin: 2 }}>
                  <p><strong>{this.props.rowName}</strong></p>
                  <p onClick={() => this.setState({ mouseOver: false })} style={{ cursor: 'pointer' }}>x</p>
                </div>
                <div style={{ padding: '0 16px 16px', fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                  {this.props.hover}
                </div>
              </div>
            </div>
          )}
        </div>
        <div style={{ display: this.props.errMsg ? 'block' : 'none', width: '100%', marginLeft: 5, paddingBottom: 5 }}><span style={{ color: 'red', fontSize: 12 }}>{this.props.errMsg}</span></div>
      </div>
    )
  }
}
InputRow.propTypes = {
  name: PropTypes.any.isRequired,
  rowName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  required: PropTypes.string,
  hover: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  data: PropTypes.array,
  onKeyPress: PropTypes.func,
  errMsg: PropTypes.string
}
